var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHamburgerIcon = function SvgHamburgerIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4306",
    "data-name": "Group 4306",
    transform: "translate(-45 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4305",
    "data-name": "Group 4305",
    transform: "translate(45 58.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M242.773,188.135a1.58,1.58,0,0,1,.24.043,1.439,1.439,0,0,1,.717.459,1.507,1.507,0,0,1,.255.43,1.574,1.574,0,0,1,.1.493,1.521,1.521,0,0,1-.735,1.367,1.407,1.407,0,0,1-.458.167,1.321,1.321,0,0,1-.243.022H215.815a1.305,1.305,0,0,1-.243-.022,1.42,1.42,0,0,1-.752-.393,1.466,1.466,0,0,1-.288-.406,1.533,1.533,0,0,1,.288-1.749,1.492,1.492,0,0,1,.293-.226,1.4,1.4,0,0,1,.459-.167,1.3,1.3,0,0,1,.243-.022h26.836l.122,0Z",
    transform: "translate(-214.377 -188.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M242.767,266.881a1.575,1.575,0,0,1,.24.043,1.438,1.438,0,0,1,.717.459,1.507,1.507,0,0,1,.255.43,1.55,1.55,0,0,1-.255,1.542,1.444,1.444,0,0,1-.378.318,1.408,1.408,0,0,1-.458.167,1.32,1.32,0,0,1-.243.022H215.809a1.3,1.3,0,0,1-.243-.022,1.425,1.425,0,0,1-.459-.167,1.509,1.509,0,0,1-.724-1.114,1.569,1.569,0,0,1,0-.38,1.52,1.52,0,0,1,.143-.481,1.482,1.482,0,0,1,.288-.406,1.426,1.426,0,0,1,.752-.393,1.3,1.3,0,0,1,.243-.022h26.836l.122,0Z",
    transform: "translate(-214.372 -257.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M242.776,345.631a1.576,1.576,0,0,1,.24.043,1.439,1.439,0,0,1,.717.459,1.551,1.551,0,0,1,.255,1.542,1.507,1.507,0,0,1-.255.43,1.444,1.444,0,0,1-.378.318,1.407,1.407,0,0,1-.458.167,1.32,1.32,0,0,1-.243.022H215.818a1.3,1.3,0,0,1-.243-.022,1.42,1.42,0,0,1-.752-.393,1.472,1.472,0,0,1-.229-.3,1.549,1.549,0,0,1-.11-1.338,1.526,1.526,0,0,1,.255-.43,1.444,1.444,0,0,1,.378-.318,1.4,1.4,0,0,1,.459-.167,1.3,1.3,0,0,1,.243-.022h26.836l.122,0Z",
    transform: "translate(-214.38 -327.152)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_958",
    "data-name": "Rectangle 958",
    width: 30,
    height: 30,
    transform: "translate(45 54)",
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHamburgerIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburgerIcon.8c783ce6.svg";
export { ForwardRef as ReactComponent };